import React, { useState, useEffect } from 'react';
import TransactionForm from './TransactionForm';
import styles from '../styling/Dashboard.module.css';
import { useSelector } from 'react-redux';
import { CATEGORIES } from '../helpers';
// eslint-disable-next-line
import Chart from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
// eslint-disable-next-line
import { use } from 'react';
// eslint-disable-next-line
import { color } from 'chart.js/helpers';

function Dashboard() {
  const transactions = useSelector((state) => state.transactions);
  const budgets = useSelector((state) => state.budgets)

  // const [housing, setHousing] = useState(0);
  // const [food, setFood] = useState(0);
  // const [entertainment, setEntertainment] = useState(0);
  
  const [values, setValues] = useState(Object.fromEntries(CATEGORIES.map((name) => [name, 0])))

  //const [colorArray, setColorArray] = useState([])

  const assesColor = (value, category) => {
    return value > budgets[category] ? '#FA5AAA' : '#5BD98D'
  }

  const createColorArray = () => {
    const array = CATEGORIES.map(category => {
      return assesColor(values[category], category)
    })
    return array
  }

  useEffect(() => {
    CATEGORIES.forEach(category => {
      const total = transactions[category].reduce((acc, tran) => acc + Number(tran.amount), 0)
      setValues(values => ({...values, [category]: total}))
    })


    // let array = CATEGORIES.map(category => {
    //   console.log(values[category])
    //   return assesColor(values[category], category)
    // })
    // console.log(array)
    // setColorArray(array)
    // console.log(colorArray)

    // const housingTotal = transactions['Housing'].reduce(
    //   (acc, tran) => acc + Number(tran.amount),
    //   0
    // );
    // setHousing(housingTotal);
    // const foodTotal = transactions['Food'].reduce(
    //   (acc, tran) => acc + Number(tran.amount),
    //   0
    // );
    // setFood(foodTotal);
    // const entertainmentTotal = transactions['Entertainment'].reduce(
    //   (acc, tran) => acc + Number(tran.amount),
    //   0
    // );
    //setEntertainment(entertainmentTotal);
  }, [transactions]);

  return (
    <div className={styles.div}>
      <TransactionForm />

      <Bar
        data={{
          labels: CATEGORIES,
          datasets: [
            {
              type: 'line',
              label: 'Budget per category',
              data: Object.values(budgets), // [budgets['Housing'], budgets['Food'], budgets['Entertainment']]
              backgroundColor: 'red',
              borderColor: 'red',
            },
            {
              type: 'bar',
              label: 'Spending per category',
              data: Object.values(values),
              backgroundColor: createColorArray, //[assesColor(housing, 'Housing'), assesColor(food, 'Food'), assesColor(entertainment, 'Entertainment')]
            },
            
          ],
        }}
        className={styles.chart}
      />

    </div>
  );
}

export default Dashboard;
